import { atom } from "recoil";
import { ICv } from "../../../../commons/types/crm";

export const cvAtom = atom<ICv[]>({
  key: 'cv',
  default: [] as ICv[],
});

